import { useParams } from 'react-router';

import { isScope, type Scope } from '@/domain/types';

/** The scope in the URL, or null when the segment is not one of the four pages. */
export function useScopeParam(): Scope | null {
  const { scope } = useParams();
  return isScope(scope) ? scope : null;
}

export function scopePath(scope: Scope, ...rest: string[]): string {
  return ['/scopes', scope, ...rest].join('/');
}

export function proposalPath(id: string): string {
  return `/proposals/${encodeURIComponent(id)}`;
}

export function runsPath(scope: Scope, capabilityId: string): string {
  return scopePath(scope, 'components', encodeURIComponent(capabilityId), 'runs');
}

export function configPath(scope: Scope, capabilityId?: string, sub?: 'history'): string {
  const parts = ['config'];
  if (capabilityId) parts.push(encodeURIComponent(capabilityId));
  if (sub) parts.push(sub);
  return scopePath(scope, ...parts);
}
